'use strict'
module.exports = {
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_EMAIL_SUPPORT: 'SEND_EMAIL_SUPPORT',
  EMAIL_LIST: 'EMAIL_LIST',
  CLEAR_EMAIL: 'CLEAR_EMAIL',
  REQUESTED: '_REQUESTED'
}



// WEBPACK FOOTER //
// ./src/redux/types/email.js